export const PropertyKeyType = {
	propertyUnitDoor: 'property-unit-door',
}
